module.exports = __webpack_public_path__ + "img/slogan.dd18c390.png";